import axios from "axios";

let url = "/api/console/messages";

export default {
    getMessages(data) {
        return axios.get(url, data).then(result => result.data);
    },
    getMessage(data) {
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    putMessage(data) {
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    testMessage(data) {
        return axios.post(`${url}/test`, data).then(result => result.data);
    },
}